var a = function(n) {
  return n != null;
}, C = function(n) {
  return n == null;
}, k = function(n) {
  return Array.isArray(n);
}, b = function(n) {
  return typeof n == "function";
}, w = function(n) {
  return typeof n == "string";
}, K = function(n) {
  return C(n) || n.trim().length === 0;
}, X = function(n) {
  return !K(n);
}, y = function(n) {
  return !isNaN(n - parseFloat(n));
}, p = function(n) {
  return n && n.getTime;
}, E = function(n) {
  return a(n.filters);
};
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
var d = function(n, r) {
  return d = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(t, e) {
    t.__proto__ = e;
  } || function(t, e) {
    for (var u in e)
      e.hasOwnProperty(u) && (t[u] = e[u]);
  }, d(n, r);
};
function nr(n, r) {
  d(n, r);
  function t() {
    this.constructor = n;
  }
  n.prototype = r === null ? Object.create(r) : (t.prototype = r.prototype, new t());
}
function Q() {
  for (var n = 0, r = 0, t = arguments.length; r < t; r++)
    n += arguments[r].length;
  for (var e = Array(n), u = 0, r = 0; r < t; r++)
    for (var o = arguments[r], i = 0, f = o.length; i < f; i++, u++)
      e[u] = o[i];
  return e;
}
var V = function(n, r, t) {
  return function(e) {
    return n(e) ? r(e) : t(e);
  };
}, c = function() {
  for (var n = [], r = 0; r < arguments.length; r++)
    n[r] = arguments[r];
  return function(t) {
    return n.reduceRight(function(e, u) {
      return u(e);
    }, t);
  };
}, Z = function(n) {
  return new Date(Date.UTC(n.getFullYear(), n.getMonth(), n.getDate(), n.getHours(), n.getMinutes(), n.getSeconds(), n.getMilliseconds()));
}, nn = function(n) {
  return p(n.value);
}, rn = function(n) {
  return {
    "!=": "neq",
    "<": "lt",
    "<=": "lte",
    "==": "eq",
    ">": "gt",
    ">=": "gte",
    equal: "eq",
    equals: "eq",
    equalto: "eq",
    ge: "gte",
    greater: "gt",
    greaterthan: "gt",
    greaterthanequal: "gte",
    isempty: "isempty",
    isequalto: "eq",
    isgreaterthan: "gt",
    isgreaterthanorequalto: "gte",
    islessthan: "lt",
    islessthanorequalto: "lte",
    isnotempty: "isnotempty",
    isnotequalto: "neq",
    isnull: "isnull",
    le: "lte",
    less: "lt",
    lessthan: "lt",
    lessthanequal: "lte",
    ne: "neq",
    notequal: "neq",
    notequals: "neq",
    notequalto: "neq",
    notsubstringof: "doesnotcontain"
  }[n.toLowerCase()] || n;
}, z = function(n) {
  n.filters && (n.filters = n.filters.map(function(r) {
    var t = Object.assign({}, r);
    return !E(r) && w(r.operator) && (t.operator = rn(r.operator)), E(r) && z(t), t;
  }));
}, tn = function(n) {
  return E(n) ? Object.assign({}, n) : {
    filters: k(n) ? n : [n],
    logic: "and"
  };
}, M = function(n) {
  return a(n) && (n = tn(n), z(n)), n;
}, q = {}, en = /\[(?:(\d+)|['"](.*?)['"])\]|((?:(?!\[.*?\]|\.).)+)/g;
q.undefined = function(n) {
  return n;
};
var g = function(n, r) {
  var t = n + r;
  if (q[t])
    return q[t];
  var e = [];
  return n.replace(en, function(u, o, i, f) {
    e.push(a(o) ? o : i || f);
  }), q[t] = function(u) {
    for (var o = u, i = 0; i < e.length; i++)
      if (o = o[e[i]], !a(o) && r)
        return o;
    return o;
  }, q[t];
}, N = function(n) {
  return function(r) {
    return [n, r];
  };
}, un = function() {
  return null;
}, on = function(n) {
  return a(n) && k(n) && n.length > 0;
}, an = function(n) {
  return function(r) {
    return on(n(r));
  };
}, fn = function(n, r) {
  return V(n, r, un);
}, cn = function(n) {
  var r = n.skip, t = n.take;
  return Math.floor((r || 0) / t) + 1;
}, S = function(n, r) {
  return function(t) {
    return n(t).map(r).join("~");
  };
}, sn = function(n) {
  return function(r) {
    return r.slice(0, r.indexOf(n));
  };
}, ln = function(n) {
  return c.apply(void 0, n.map(function(r) {
    var t = r[0], e = r[1];
    return function(u) {
      return u.replace(new RegExp(t, "g"), e);
    };
  }));
}, gn = ln([['"', ""], [":", "-"]]), vn = sn("."), x = function(n) {
  var r = n.field, t = n.dir, e = t === void 0 ? "asc" : t;
  return r + "-" + e;
}, mn = function(n) {
  var r = n.field, t = n.aggregate;
  return r + "-" + t;
}, hn = g("take"), pn = g("aggregates");
g("skip");
var yn = g("group"), T = g("sort", !0), qn = S(T, x), En = S(yn, x), Nn = S(pn, mn), Cn = function(n) {
  return "datetime'" + n + "'";
}, dn = c(Cn, vn, gn, JSON.stringify, Z), Dn = function(n) {
  var r = n.field, t = n.value, e = n.ignoreCase, u = n.operator;
  return {
    value: dn(t),
    field: r,
    ignoreCase: e,
    operator: u
  };
}, kn = function(n) {
  return Object.assign({}, n, {
    sort: (T(n) || []).filter(function(r) {
      var t = r.dir;
      return X(t);
    })
  });
};
c(N("page"), cn);
c(N("pageSize"), hn);
c(N("group"), En);
var wn = c(N("sort"), qn);
c(N("aggregate"), Nn);
c(fn(an(T), wn), kn);
var O = function(n) {
  var r = n.field, t = n.operator, e = n.value;
  return r + "~" + t + "~" + e;
};
V(nn, c(O, Dn), O);
var P = function(n, r, t) {
  return r[n] = t, r;
}, R = function(n) {
  return function(r) {
    return Object.keys(r).reduce(n.bind(null, r), {});
  };
}, Sn = R(function(n, r, t) {
  return P(t.toLowerCase(), r, n[t]);
}), Tn = R(function(n, r, t) {
  return P(t, r, Sn(n[t]));
}), _ = function(n, r) {
  return a(n) ? n : r;
}, An = function(n) {
  return {
    aggregates: n.Aggregates || n.aggregates,
    field: n.Member || n.member || n.field,
    hasSubgroups: n.HasSubgroups || n.hasSubgroups || !1,
    items: n.Items || n.items,
    value: _(n.Key, _(n.key, n.value))
  };
}, In = c(function(n) {
  var r = n.field, t = n.hasSubgroups, e = n.value, u = n.aggregates, o = n.items;
  return {
    aggregates: Tn(u),
    field: r,
    items: t ? o.map(In) : o,
    value: e
  };
}, An), B = function(n, r) {
  return C(n) ? n === r ? 0 : -1 : C(r) ? 1 : n.localeCompare ? n.localeCompare(r) : n > r ? 1 : n < r ? -1 : 0;
}, bn = function(n, r) {
  return B(r, n);
}, On = function(n) {
  if (typeof n.compare == "function")
    return n.compare;
  var r = g(n.field, !0);
  return function(t, e) {
    return (n.dir === "asc" ? B : bn)(r(t), r(e));
  };
}, _n = function(n, r) {
  return 0;
}, jn = function(n) {
  return n.filter(function(r) {
    return a(r.dir) || a(r.compare);
  }).map(function(r) {
    return On(r);
  }).reduce(function(r, t) {
    return function(e, u) {
      return r(e, u) || t(e, u);
    };
  }, _n);
}, Gn = function(n) {
  return n = a(n) && n.getTime ? n.getTime() : n, n + "";
}, Ln = function(n) {
  var r = g(n, !0), t = 0;
  return function(e, u) {
    e[n] = e[n] || {};
    var o = r(u), i = Gn(o), f = e[n][i] || { __position: t++, aggregates: {}, items: [], value: o };
    return f.items.push(u), e[n][i] = f, e;
  };
}, Vn = function(n) {
  return n === void 0 && (n = {}), Object.keys(n).forEach(function(r) {
    var t = n[r];
    Object.keys(t).forEach(function(e) {
      t[e] = t[e].result();
    });
  }), n;
}, zn = function(n) {
  return {
    average: function() {
      var r = 0, t = 0;
      return {
        calc: function(e) {
          y(e) ? (r += e, t++) : r = e;
        },
        result: function() {
          return y(r) ? r / t : r;
        }
      };
    },
    count: function() {
      var r = 0;
      return {
        calc: function() {
          return r++;
        },
        result: function() {
          return r;
        }
      };
    },
    max: function() {
      var r = Number.NEGATIVE_INFINITY;
      return {
        calc: function(t) {
          r = y(r) || p(r) ? r : t, r < t && (y(t) || p(t)) && (r = t);
        },
        result: function() {
          return r;
        }
      };
    },
    min: function() {
      var r = Number.POSITIVE_INFINITY;
      return {
        calc: function(t) {
          r = y(r) || p(r) ? r : t, r > t && (y(t) || p(t)) && (r = t);
        },
        result: function() {
          return r;
        }
      };
    },
    sum: function() {
      var r = 0;
      return {
        calc: function(t) {
          t = a(t) ? t : 0, r += t;
        },
        result: function() {
          return r;
        }
      };
    }
  }[n]();
}, Mn = function(n) {
  var r = n.map(function(t) {
    var e = g(t.field, !0), u = (t.aggregate || "").toLowerCase(), o = g(u, !0);
    return function(i, f) {
      var s = i[t.field] || {}, v = o(s) || zn(u);
      return v.calc(e(f)), s[t.aggregate] = v, i[t.field] = s, i;
    };
  });
  return function(t, e) {
    return r.reduce(function(u, o) {
      return o(u, e);
    }, t);
  };
}, xn = function(n, r) {
  return n.push(r), n;
}, F = function(n) {
  return function(r) {
    return function(t, e, u) {
      return r(t, n(e, u));
    };
  };
}, j = function(n) {
  return function(r) {
    return function(t, e) {
      return n(e) ? r(t, e) : t;
    };
  };
}, W = function(n) {
  return a(n.__value);
}, Pn = function(n) {
  return W(n) ? n : {
    __value: n,
    reduced: !0
  };
}, Rn = function(n) {
  return function(r) {
    return function(t, e) {
      return n-- > 0 ? r(t, e) : Pn(t);
    };
  };
}, Bn = function(n) {
  return function(r) {
    return function(t, e) {
      return n-- <= 0 ? r(t, e) : t;
    };
  };
}, A = function(n, r, t) {
  for (var e = r, u = 0, o = t.length; u < o; u++)
    if (e = n(e, t[u], u), W(e)) {
      e = e.__value;
      break;
    }
  return e;
}, Fn = F(function(n) {
  return n;
}), Wn = function(n, r, t) {
  r === void 0 && (r = []), t === void 0 && (t = Fn);
  var e = {};
  if (!r.length)
    return e;
  var u = A(t(Mn(r)), e, n);
  return Vn(u);
}, Yn = {
  or: {
    concat: function(n, r) {
      return function(t) {
        return n(t) || r(t);
      };
    },
    identity: function() {
      return !1;
    }
  },
  and: {
    concat: function(n, r) {
      return function(t) {
        return n(t) && r(t);
      };
    },
    identity: function() {
      return !0;
    }
  }
}, $n = {
  contains: function(n, r) {
    return (n || "").indexOf(r) >= 0;
  },
  doesnotcontain: function(n, r) {
    return (n || "").indexOf(r) === -1;
  },
  doesnotendwith: function(n, r) {
    return (n || "").indexOf(r, (n || "").length - (r || "").length) < 0;
  },
  doesnotstartwith: function(n, r) {
    return (n || "").lastIndexOf(r, 0) === -1;
  },
  endswith: function(n, r) {
    return (n || "").indexOf(r, (n || "").length - (r || "").length) >= 0;
  },
  eq: function(n, r) {
    return n === r;
  },
  gt: function(n, r) {
    return n > r;
  },
  gte: function(n, r) {
    return n >= r;
  },
  isempty: function(n) {
    return n === "";
  },
  isnotempty: function(n) {
    return n !== "";
  },
  isnotnull: function(n) {
    return a(n);
  },
  isnull: function(n) {
    return C(n);
  },
  lt: function(n, r) {
    return n < r;
  },
  lte: function(n, r) {
    return n <= r;
  },
  neq: function(n, r) {
    return n != r;
  },
  startswith: function(n, r) {
    return (n || "").lastIndexOf(r, 0) === 0;
  }
}, Y = /^\/Date\((.*?)\)\/$/, Hn = function(n, r) {
  if (n != null && w(n)) {
    var t = Y.exec(n);
    if (t)
      return (/* @__PURE__ */ new Date(+t[1])).getTime();
    if (r)
      return n.toLowerCase();
  } else if (n != null && p(n))
    return n.getTime();
  return n;
}, Un = function(n, r, t) {
  if (!a(r))
    return n;
  var e = n;
  if (w(r)) {
    var u = Y.exec(r);
    u ? r = /* @__PURE__ */ new Date(+u[1]) : e = function(o) {
      var i = n(o);
      return typeof i == "string" && t ? i.toLowerCase() : y(i) ? i + "" : i;
    };
  }
  return p(r) ? function(o) {
    var i = e(o);
    return p(i) ? i.getTime() : i;
  } : e;
}, Jn = function(n) {
  var r = n.field, t = n.ignoreCase, e = n.value, u = n.operator;
  r = a(r) ? r : function(f) {
    return f;
  }, t = a(t) ? t : !0;
  var o = Un(b(r) ? r : g(r, !0), e, t);
  e = Hn(e, t);
  var i = b(u) ? u : $n[u];
  return function(f) {
    return i(o(f), e, t);
  };
}, $ = function(n) {
  var r = Yn[n.logic];
  return n.filters.filter(a).map(function(t) {
    return E(t) ? $(t) : Jn(t);
  }).reduce(r.concat, r.identity);
}, H = function(n) {
  return !n || n.filters.length === 0 ? function() {
    return !0;
  } : $(n);
}, Kn = function(n, r) {
  return !a(r) || E(r) && r.filters.length === 0 ? n : n.filter(H(M(r)));
}, U = function(n) {
  return n = k(n) ? n : [n], n.map(function(r) {
    return Object.assign({ dir: "asc" }, r);
  });
}, G = F(function(n) {
  return n;
}), D = function(n, r, t, e) {
  if (r === void 0 && (r = []), t === void 0 && (t = G), e === void 0 && (e = n), r = U(r), !r.length)
    return n;
  var u = r[0], o = {}, i = A(t(Ln(u.field)), o, n), f = [];
  return Object.keys(i).forEach(function(s) {
    Object.keys(i[s]).forEach(function(v) {
      var l = i[s][v], m = {}, h = e;
      a(u.aggregates) && (h = Kn(e, {
        field: u.field,
        ignoreCase: !1,
        operator: "eq",
        value: l.value
      }), m = Wn(h, u.aggregates)), f[l.__position] = {
        aggregates: m,
        field: s,
        items: r.length > 1 ? D(l.items, r.slice(1), G, h) : l.items,
        value: l.value
      };
    });
  }), f;
}, Xn = function(n, r) {
  if (r.some(function(e) {
    return a(e.dir) || a(e.compare);
  })) {
    n = n.slice(0);
    var t = jn(r);
    n.sort(t);
  }
  return n;
}, Qn = function(n, r) {
  for (var t = 0, e = 0, u = n.length; e < u; e++)
    r(n[e]) && t++;
  return t;
}, Zn = function(n, r) {
  return r ? n.filter(r) : n;
}, rr = function(n, r) {
  var t = r.skip, e = r.take, u = r.filter, o = r.sort, i = r.group, f = Q(U(i || []), o || []);
  f.length && (n = Xn(n, f));
  var s = a(u) && j.length, v = a(i) && i.length;
  if (!s && !v)
    return {
      data: e ? n.slice(t, t + e) : n,
      total: n.length
    };
  var l, m = [], h;
  if (s ? (h = H(M(u)), l = Qn(n, h), m.push(j(h))) : l = n.length, a(t) && a(e) && (m.push(Bn(t)), m.push(Rn(e))), m.length) {
    var I = c.apply(void 0, m), J = v ? D(n, i, I, Zn(n, h)) : A(I(xn), [], n);
    return { data: J, total: l };
  }
  return {
    data: v ? D(n, i) : n,
    total: l
  };
}, L;
(function(n) {
  n.Contains = "contains", n.DoesNotContain = "doesnotcontain", n.DoesNotEndWith = "doesnotendwith", n.DoesNotStartWith = "doesnotstartwith", n.EndsWith = "endswith", n.EqualTo = "eq", n.GreaterThan = "gt", n.GreaterThanOrEqual = "gte", n.IsEmpty = "isempty", n.IsNotEmpty = "isnotempty", n.IsNotNull = "isnotnull", n.IsNull = "isnull", n.LessThan = "lt", n.LessThanOrEqual = "lte", n.NotEqualTo = "neq", n.StartsWith = "startswith";
})(L || (L = {}));
export {
  nr as _,
  Kn as f,
  E as i,
  Xn as o,
  rr as p
};
